import { render, staticRenderFns } from "./AturEkspedisi.html?vue&type=template&id=3bc57448&"
import script from "./AturEkspedisi.js?vue&type=script&lang=js&"
export * from "./AturEkspedisi.js?vue&type=script&lang=js&"
import style0 from "./AturEkspedisi.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports